import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CustomButton from '../button/Button';
import Avatar from '@mui/material/Avatar';
import PropTypes from 'prop-types';
import './AlertDialog.scss';

const AlertBox = ({
  open,
  onClose,
  title,
  content,
  actions=[],
  avatars,
  variant = 'sm', // xs, sm, md, lg
  ...props
}) => {
  const buttonRef = React.useRef(null);
  return (
    <Dialog
      className="alert-wrapper"
      open={open}
      onClose={onClose}
      maxWidth={variant}
      fullWidth
    >
      {title && (
        <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
          {avatars && <Avatar>{avatars}</Avatar>}
          {title}
        </DialogTitle>
      )}
      {content && <DialogContent>{content}</DialogContent>}
      <DialogActions>
        {actions?.map((actionItem, index) => (
          <CustomButton
            className={actionItem?.class}
            key={index}
            onClick={actionItem?.action}
            loading={actionItem?.loading}
            ref={buttonRef}
            onKeyDown={(event) => event.key === 'Enter' && buttonRef?.current?.click() }
          >
            {actionItem.name}
          </CustomButton>
        ))}
      </DialogActions>
    </Dialog>
  );
};

AlertBox.propTypes = {
  open: PropTypes.any,
  onClose: PropTypes.any,
  title: PropTypes.any,
  content: PropTypes.any,
  actions: PropTypes.any,
  avatars: PropTypes.any,
  variant: PropTypes.any, 
};

export default AlertBox;
